import en from '@/locales/translations/en/en.json'
import common from '@/locales/translations/en/common.json'
import glossary from '@/locales/translations/en/glossary.json'
import validation from '@/locales/translations/en/validation.json'

export default {
  translation: en,
  common: common,
  glossary: glossary,
  validation: validation,
}
